const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.67 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.33,16h2c.18,0,.33-.15,.33-.33V.33c0-.18-.15-.33-.33-.33h-2c-.18,0-.33,.15-.33,.33V15.67c0,.18,.15,.33,.33,.33Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.33,16H2.33c.18,0,.33-.15,.33-.33v-6c0-.18-.15-.33-.33-.33H.33c-.18,0-.33,.15-.33,.33v6c0,.18,.15,.33,.33,.33Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34,16h1.99c.19,0,.34-.15,.34-.33h0V7c0-.19-.15-.34-.33-.34h-2c-.19,0-.34,.15-.34,.33h0V15.66c0,.19,.15,.34,.33,.34h0Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3V15.66c0,.19,.15,.34,.33,.34h2c.19,0,.34-.15,.34-.33h0V3c0-.19-.15-.34-.33-.34h-2c-.19,0-.34,.15-.34,.33h0Z",
    style: {
      fill: "#ccc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartIcon);
export default __webpack_public_path__ + "static/media/bar-chart-icon.4a806829458d0e565103000ff6217b59.svg";
export { ForwardRef as ReactComponent };